class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.subDetailsToggle = this.querySelectorAll('.header__submenu details');

    if (!this.mainDetailsToggle) return;

    this.content = this.mainDetailsToggle.querySelector('summary')?.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    this.subDetailsToggle.forEach((submenu) => {
      submenu.addEventListener('toggle', () => {
        if (submenu.open) {
          const parentLevel = submenu.closest('.header__submenu_grand, .header__submenu');

          // 1. CLOSE siblings in current LEVEL
          parentLevel.querySelectorAll(':scope > li > details').forEach((other) => {
            if (other !== submenu) {
              other.removeAttribute('open');
            }
          });

          // 2. CLOSE grandchildren in OTHER Level-2 menus
          const allGrandChildDetails = document.querySelectorAll('.header__submenu_grand details');

          allGrandChildDetails.forEach((gc) => {
            // Close ALL grandchildren except those that belong to the submenu currently opened
            if (!submenu.contains(gc)) {
              gc.removeAttribute('open');
            }
          });
        }

        requestAnimationFrame(() => this.checkSubmenuOverflow(submenu));
      });

    });
    
    requestAnimationFrame(() => {
      this.subDetailsToggle.forEach((submenu) => this.checkSubmenuOverflow(submenu));
    });
  }

  checkSubmenuOverflow(submenu) {
    const parent = submenu.closest('.header__submenu');
    if (!parent) return;

    const panel = submenu.querySelector('summary')?.nextElementSibling || submenu;
    if (!panel) return;

    const rect = panel.getBoundingClientRect();

    if (rect.right > window.innerWidth || rect.left < 0) {
      parent.classList.add('hase-reverse');
    } else {
      const isTopLevel = parent.closest('details') === null;
      if (isTopLevel) parent.classList.remove('hase-reverse');
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.content) return;

    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');


    window.addEventListener('resize', () => this.recomputeOverflow());
    window.addEventListener('scroll', () => this.recomputeOverflow(), true);


    requestAnimationFrame(() => this.recomputeOverflow());
  }

  recomputeOverflow() {
    this.subDetailsToggle?.forEach((submenu) => this.checkSubmenuOverflow(submenu));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
























// class DetailsDisclosure extends HTMLElement {
//   constructor() {
//     super();
//     this.mainDetailsToggle = this.querySelector('details');
//     this.subDetailsToggle = this.querySelectorAll('.header__submenu details');

//     if (!this.mainDetailsToggle) return;

//     this.content = this.mainDetailsToggle.querySelector('summary')?.nextElementSibling;

//     this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    

//     this.subDetailsToggle.forEach((submenu) => {
//       submenu.addEventListener('toggle', () => {
//         if (submenu.open) {
//           this.subDetailsToggle.forEach((other) => {
//             if (other !== submenu) other.removeAttribute('open');
//           });
//         }

//         requestAnimationFrame(() => this.checkSubmenuOverflow(submenu));
//       });
//     });

//     requestAnimationFrame(() => {
//       this.subDetailsToggle.forEach((submenu) => this.checkSubmenuOverflow(submenu));
//     });
//   }

//   checkSubmenuOverflow(submenu) {
//     const parent = submenu.closest('.header__submenu');
//     if (!parent) return;

//     const panel = submenu.querySelector('summary')?.nextElementSibling || submenu;
//     if (!panel) return;

//     const rect = panel.getBoundingClientRect();

//     if (rect.right > window.innerWidth || rect.left < 0) {
//       parent.classList.add('hase-reverse');
//     } else {
//       const isTopLevel = parent.closest('details') === null;
//       if (isTopLevel) parent.classList.remove('hase-reverse');
//     }
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   onToggle() {
//     if (!this.content) return;

//     if (!this.animations) this.animations = this.content.getAnimations();

//     if (this.mainDetailsToggle.hasAttribute('open')) {
//       this.animations.forEach((animation) => animation.play());
//     } else {
//       this.animations.forEach((animation) => animation.cancel());
//     }
//   }

//   close() {
//     if (!this.mainDetailsToggle) return;
//     this.mainDetailsToggle.removeAttribute('open');
//     this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', false);
//   }
// }

// customElements.define('details-disclosure', DetailsDisclosure);

// class HeaderMenu extends DetailsDisclosure {
//   constructor() {
//     super();
//     this.header = document.querySelector('.header-wrapper');


//     window.addEventListener('resize', () => this.recomputeOverflow());
//     window.addEventListener('scroll', () => this.recomputeOverflow(), true);


//     requestAnimationFrame(() => this.recomputeOverflow());
//   }

//   recomputeOverflow() {
//     this.subDetailsToggle?.forEach((submenu) => this.checkSubmenuOverflow(submenu));
//   }

//   onToggle() {
//     if (!this.header) return;
//     this.header.preventHide = this.mainDetailsToggle.open;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }
// }

// customElements.define('header-menu', HeaderMenu);






















































// class DetailsDisclosure extends HTMLElement {
//   constructor() {
//     super();
//     this.mainDetailsToggle = this.querySelector('details');
//     this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

//     this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   onToggle() {
//     if (!this.animations) this.animations = this.content.getAnimations();

//     if (this.mainDetailsToggle.hasAttribute('open')) {
//       this.animations.forEach((animation) => animation.play());
//     } else {
//       this.animations.forEach((animation) => animation.cancel());
//     }
//   }

//   close() {
//     this.mainDetailsToggle.removeAttribute('open');
//     this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
//   }
// }

// customElements.define('details-disclosure', DetailsDisclosure);

// class HeaderMenu extends DetailsDisclosure {
//   constructor() {
//     super();
//     this.header = document.querySelector('.header-wrapper');
//   }

//   onToggle() {
//     if (!this.header) return;
//     this.header.preventHide = this.mainDetailsToggle.open;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }
// }

// customElements.define('header-menu', HeaderMenu);

